import { render } from "./sellers.vue?vue&type=template&id=044438db&scoped=true"
import script from "./sellers.vue?vue&type=script&lang=js"
export * from "./sellers.vue?vue&type=script&lang=js"

import "./sellers.vue?vue&type=style&index=0&id=044438db&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-044438db"]])

export default __exports__